/* tslint:disable */
/* eslint-disable */
/**
 * Adyen Card Enrollment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Payment
 */
export interface Payment {
    /**
     * From the drop-in component: pass the value of state.data.paymentMethod from the onSubmit event.
     * @type {object}
     * @memberof Payment
     */
    adyenPaymentMethod: object;
    /**
     * From the drop-in component: pass the value of state.data.browserInfo from the onSubmit event.
     * @type {object}
     * @memberof Payment
     */
    browserInfo?: object;
    /**
     * From the drop-in component: pass the value of state.data.riskData from the onSubmit event.
     * @type {object}
     * @memberof Payment
     */
    riskData?: object;
    /**
     * From the drop-in component: pass the value of state.data.origin from the onSubmit event.
     * @type {string}
     * @memberof Payment
     */
    origin?: string;
    /**
     * Optional field to specify `returnURL` in the freestanding case. Not used in the regular card enrollment flow.
     * @type {string}
     * @memberof Payment
     */
    returnURL?: string;
    /**
     * Optional field to send the seed value used when creating the access token for
     * freestanding card payments.
     * @type {string}
     * @memberof Payment
     */
    seed?: string;
}

export function PaymentFromJSON(json: any): Payment {
    return PaymentFromJSONTyped(json, false);
}

export function PaymentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Payment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'adyenPaymentMethod': json['adyenPaymentMethod'],
        'browserInfo': !exists(json, 'browserInfo') ? undefined : json['browserInfo'],
        'riskData': !exists(json, 'riskData') ? undefined : json['riskData'],
        'origin': !exists(json, 'origin') ? undefined : json['origin'],
        'returnURL': !exists(json, 'returnURL') ? undefined : json['returnURL'],
        'seed': !exists(json, 'seed') ? undefined : json['seed'],
    };
}

export function PaymentToJSON(value?: Payment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'adyenPaymentMethod': value.adyenPaymentMethod,
        'browserInfo': value.browserInfo,
        'riskData': value.riskData,
        'origin': value.origin,
        'returnURL': value.returnURL,
        'seed': value.seed,
    };
}

